import React from "react";
import { Props } from "./types";
import styles from "./styles.scss";
import { Loader } from "@common/loader";
import { DocumentCard } from "./documentCard";
import { useElementAttachmentsRetrieval } from "@planzone/view-models";
import { Preview } from "@common/preview";
import { Identifiable, Document } from "@planzone/dto";

function ElementAttachments({ project, element, elementType }: Props) {
  const [selectedDocument, setSelectedDocument] =
    React.useState<Identifiable<Document> | null>(null);

  const {
    isRequestPending: isElementAttachmentsRetrievalPending,
    hasRetrievedElementAttachments,
    attachments,
    retrieveElementAttachments,
  } = useElementAttachmentsRetrieval(element.uuid);

  React.useEffect(() => {
    if (
      project.uuid !== "" &&
      element.uuid !== "" &&
      !hasRetrievedElementAttachments
    ) {
      retrieveElementAttachments({
        elementId: element.uuid,
        elementType,
        projectId: project.uuid,
      });
    }
  }, [element.uuid, project.uuid, hasRetrievedElementAttachments]);

  return (
    <div className={styles.elementAttachments}>
      <div>
        {isElementAttachmentsRetrievalPending ? (
          <div className={styles.loaderContainer}>
            <Loader />
          </div>
        ) : (
          <div>
            <ul className={styles.list}>
              {attachments.map((doc) => (
                <DocumentCard
                  element={element}
                  elementType={elementType}
                  key={doc.uuid}
                  document={doc}
                  openPreview={(document) => {
                    setSelectedDocument(document);
                  }}
                />
              ))}
            </ul>
          </div>
        )}
      </div>
      {selectedDocument && (
        <Preview
          document={selectedDocument}
          close={() => setSelectedDocument(null)}
        />
      )}
    </div>
  );
}

export { ElementAttachments };
